import { render, staticRenderFns } from "./createWxOrder.vue?vue&type=template&id=6b33152a&scoped=true"
import script from "./createWxOrder.vue?vue&type=script&lang=js"
export * from "./createWxOrder.vue?vue&type=script&lang=js"
import style0 from "./createWxOrder.vue?vue&type=style&index=0&id=6b33152a&prod&scoped=true&lang=css"
import style1 from "./createWxOrder.vue?vue&type=style&index=1&id=6b33152a&prod&lang=css"
import style2 from "./createWxOrder.vue?vue&type=style&index=2&id=6b33152a&prod&scoped=true&lang=scss"
import style3 from "./createWxOrder.vue?vue&type=style&index=3&id=6b33152a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33152a",
  null
  
)

export default component.exports